export const articleDetails: Record<string, {
  id: string;
  title: string;
  summary: string;
  quote: string;
  author: string;
  date: string;
  category: string;
  tag: string;
  image: string;
  content: string;
  relatedIds: string[];
}> = {
  'article-001': {
    id: 'article-001',
    title: '知名男星深夜密会神秘女子，酒店同框照流出',
    summary: '被拍到与一位神秘女子深夜同进酒店，次日早晨才分别离开，引发婚变猜测。',
    quote: '在娱乐圈，每一扇酒店大门背后都可能藏着不愿被人知晓的秘密。而这一次，镜头捕捉到的是一个足以撼动一个家庭的故事。',
    author: '吃瓜小编',
    date: '2026-07-06',
    category: '明星黑料',
    tag: '实锤',
    image: 'https://readdy.ai/api/search-image?query=A%20blurry%20paparazzi%20style%20night%20shot%20of%20a%20luxury%20hotel%20entrance%20with%20warm%20golden%20lights%2C%20silhouette%20figures%20in%20the%20distance%2C%20dramatic%20moody%20night%20atmosphere%2C%20dark%20ambient%20lighting%2C%20tabloid%20magazine%20photography%20style%2C%20mysterious%20vibe&width=800&height=600&seq=article-gossip-01&orientation=landscape',
    content: `<p>7月5日晚间，有网友在社交平台发布了一组偷拍照片，照片中可以看到知名男星张某与一位身着黑色连衣裙的神秘女子在某五星级酒店大堂内亲密交谈。据拍摄者描述，两人于当晚约10点30分左右先后进入酒店，直到次日早晨8点左右才分别离开。</p>
<p>消息一出，立即在网络上引发轩然大波。要知道，张某与妻子李某结婚已有八年，育有一子一女，一直以"模范夫妻"的形象示人。两人曾多次在综艺节目中大秀恩爱，张某更是在采访中多次表示"妻子是此生最爱的人"。</p>
<p>这组照片的流出无疑给这对"模范夫妻"的形象带来了巨大冲击。有网友翻出张某妻子李某的社交账号，发现她最近一条动态是三天前发布的一张独自带孩子的照片，配文"有些路，终究要自己走"。这条动态在此次事件曝光后，被网友解读为"早已知道真相的暗示"。</p>
<p>截至发稿前，张某及其工作室尚未对此事做出任何回应。但据知情人士透露，张某的经纪团队正在紧急开会商讨危机公关方案。而那位神秘女子的身份也引发了网友的猜测，有人指出她疑似是某影视公司的制片人，与张某有多次合作。</p>
<p>值得注意的是，这并非张某第一次陷入绯闻。去年就有媒体爆料他与某女演员在剧组期间关系暧昧，但当时张某方迅速否认，并发布了律师函警告，事情最终不了了之。而这一次，有照片为证，事情的走向显然会更加复杂。</p>
<p>目前，张某的多个商业代言品牌已经开始调整宣传策略，部分品牌已悄悄撤下了他的宣传物料。一位品牌公关人士透露："如果事态继续恶化，不排除提前解约的可能。"</p>
<p>我们将持续关注此事的后续发展。</p>`,
    relatedIds: ['article-003', 'article-006', 'article-012', 'article-015'],
  },
  'article-002': {
    id: 'article-002',
    title: '美妆博主被爆虚假宣传，粉丝实测产品效果天差地别',
    summary: '多位粉丝晒出实测对比图，揭露某带货美妆博主夸大产品功效，评论区已沦陷。',
    quote: '当滤镜和美颜被一一剥离，镜头背后那些被精心包装的"真实测评"，究竟还剩几分真实？',
    author: '吃瓜小编',
    date: '2026-07-05',
    category: '博主反差',
    tag: '热议',
    image: 'https://readdy.ai/api/search-image?query=A%20messy%20vanity%20desk%20with%20scattered%20cosmetics%20and%20broken%20mirror%2C%20half%20opened%20lipstick%20and%20foundation%20bottles%2C%20dramatic%20side%20lighting%20creating%20harsh%20shadows%2C%20beauty%20scandal%20concept%2C%20editorial%20photography%20with%20warm%20neutral%20background%2C%20cinematic%20composition&width=800&height=600&seq=article-gossip-02&orientation=landscape',
    content: `<p>近日，拥有超过三百万粉丝的美妆博主"小美Daily"被多位粉丝联合曝光，指控其在直播和视频中对合作品牌产品进行虚假宣传。粉丝们自发组织了"真实测评"活动，将实际使用效果与博主展示的效果进行了逐一对比，结果令人震惊。</p>
<p>以一款售价高达899元的精华液为例，"小美Daily"在视频中称"使用一周就能看到明显淡化细纹的效果"，并展示了使用前后的对比图。然而，多位购买同款产品的粉丝反馈，连续使用三周后几乎看不到任何变化。有粉丝将实测照片整理发到评论区："完全是两回事，博主展示的效果图明显经过后期处理。"</p>
<p>更令人气愤的是，有细心的网友发现，该博主不同视频中展示的"使用前"照片竟然是同一张，只是调整了皮肤的色温和亮度。"这是在把粉丝当傻子耍。"一位愤怒的粉丝在评论区写道。</p>
<p>事件发酵后，"小美Daily"发布了一段道歉视频，称"可能存在个体差异"，并承诺"以后会更加严谨地测试产品"。但这段道歉显然未能平息众怒，评论区几乎一边倒地出现了要求退款的声音。据不完全统计，仅在微博平台，相关的投诉量已经超过了两万条。</p>
<p>值得关注的是，这起事件也引发了人们对整个美妆测评行业诚信度的质疑。多位业内人士指出，目前美妆博主的测评视频普遍存在过度美化、选择性展示等问问题，消费者在购买时需要保持理性。</p>`,
    relatedIds: ['article-007', 'article-010', 'article-014', 'article-016'],
  },
  'article-003': {
    id: 'article-003',
    title: '某女团成员被曝队内霸凌，聊天记录截图全网疯传',
    summary: '疑似内部工作人员爆料，公开多张聊天截图显示队内存在长期霸凌行为，经纪公司紧急公关。',
    quote: '舞台上光鲜亮丽的组合背后，可能隐藏着不为人知的暗流涌动。当聊天记录截图开始在网络上传播，一个偶像团体的真实面貌逐渐浮出水面。',
    author: '吃瓜小编',
    date: '2026-07-05',
    category: '明星黑料',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20chat%20messages%20on%20a%20dark%20surface%2C%20dramatic%20shadow%20play%2C%20tense%20atmosphere%2C%20warm%20amber%20light%20from%20the%20screen%20illuminating%20the%20dark%20background%2C%20mysterious%20vibe%2C%20editorial%20photography%20style%2C%20gossip%20magazine%20aesthetic&width=800&height=600&seq=article-gossip-03&orientation=landscape',
    content: `<p>7月4日深夜，一位自称是某知名女团前工作人员的匿名用户在社交平台发布了多条爆炸性消息，公开了多张团队内部聊天记录的截图。这些截图显示，该团体内存在严重的霸凌现象，老成员对新人进行排挤、孤立甚至言语侮辱，时间跨度长达两年以上。</p>
<p>根据曝光的聊天记录，一位资历较老的成员在群聊中多次使用侮辱性语言攻击新加入的成员，包括"拖后腿的""没有你就好了""看着你就烦"等。更令人震惊的是，这些言论是在包含经纪人在内的群组中发出的，而经纪人不仅没有制止，反而在部分对话中表示了默认甚至附和。</p>
<p>截图还显示，被霸凌的成员曾私下向经纪人求助，但得到的回复却是"忍一忍就过去了""这都是为了团队好"。这些冷漠的回应让长期遭受霸凌的成员陷入了严重的心理问题。</p>
<p>事件曝光后，该女团的官方社交账号评论区在短短几个小时内涌入超过十万条评论。粉丝群体迅速分裂为支持和抵制两派。有粉丝表示："如果这是真的，我以后再也不会为这个团花一分钱。"</p>
<p>经纪公司在7月5日上午发布了声明，称"聊天记录截图存在伪造嫌疑，将通过法律途径追究造谣者责任"。但这一声明并未有效平息舆论，反而因为语气强硬、缺乏细节而引发了更大的质疑。</p>
<p>业内专家指出，偶像团体的内部管理一直是行业的灰色地带。在高压的训练和竞争环境下，霸凌现象并不少见，但大多数时候都被经纪公司以"团队磨合"的名义掩盖了过去。这次事件的曝光，可能会推动行业对练习生和成员权益保护的重视。</p>`,
    relatedIds: ['article-001', 'article-006', 'article-012', 'article-008'],
  },
  'article-004': {
    id: 'article-004',
    title: '千万粉游戏主播代打实锤，直播时意外露出代练软件界面',
    summary: '知名游戏主播直播时不慎切换窗口，露出第三方代打软件界面，观众录屏证据确凿。',
    quote: '在游戏直播的世界里，"菜是原罪"，但当"菜"是装出来的，而背后的高手才是真正的操作者时，这已经不是在欺骗游戏，而是在欺骗每一个相信你的观众。',
    author: '吃瓜小编',
    date: '2026-07-04',
    category: '网红塌房',
    tag: '实锤',
    image: 'https://readdy.ai/api/search-image?query=A%20gaming%20setup%20with%20multiple%20monitors%20in%20a%20dark%20room%2C%20one%20screen%20showing%20suspicious%20software%20interface%2C%20dramatic%20neon%20RGB%20lighting%2C%20tense%20gaming%20atmosphere%2C%20esports%20streamer%20scandal%20concept%2C%20cinematic%20composition%20with%20deep%20shadows&width=800&height=600&seq=article-gossip-04&orientation=landscape',
    content: `<p>7月3日晚，知名游戏主播"战神阿飞"（粉丝量超过1200万）在一场直播中遭遇了职业生涯最大的翻车事件。在游戏加载间隙，他不慎按下了Alt+Tab快捷键切换窗口，露出了一个名为"EliteBoosting"的第三方代练软件的界面，上面清晰显示了他当前的游戏账号信息和代打状态。</p>
<p>虽然阿飞在不到一秒的时间内就切回了游戏画面，但这一瞬间已经被直播间里细心的观众截屏并录屏保存。截屏在社交平台上迅速传播后，引发了游戏直播圈的一场地震。</p>
<p>"战神阿飞"长期以来以其高超的游戏操作技术而闻名，曾多次在直播中展示惊人的反应速度和精准的瞄准能力，也因此获得了"国服第一狙击手"的称号。如果代打属实，那么这些"神操作"背后实际上是一个专业的代练团队在操作，而他本人只是一个"出镜主播"。</p>
<p>随着事件的发酵，更多内幕被陆续挖出。有知情人士透露，阿飞的代练团队至少有三人，分别负责不同的游戏模式和时段。而阿飞本人实际的游戏水平远低于直播中展示的水平，据称他连一些基础操作都不太熟练。</p>
<p>面对如潮水般涌来的质疑，阿飞在7月4日下午发布了一段道歉视频，承认了自己确实使用了代打服务。"我知道我辜负了大家的信任，我不知道该怎么解释，只能说对不起。"视频中的阿飞哽咽着说道。但这段道歉并未赢得观众的谅解，不少粉丝表示"被骗了整整三年，再也不会相信任何主播了"。</p>
<p>目前，阿飞所在直播平台已宣布暂停其直播权限，多个商业合作品牌也相继宣布终止合作。业内人士估计，此次事件给阿飞带来的直接经济损失可能超过千万元。</p>`,
    relatedIds: ['article-005', 'article-011', 'article-013', 'article-008'],
  },
  'hero-001': {
    id: 'hero-001',
    title: '顶流网红直播间翻车实录：私下言论曝光引发全网震动',
    summary: '拥有千万粉丝的知名网红在直播中被意外曝光私下不当言论，相关录音在社交媒体疯传，品牌方火速解约，粉丝群体分裂成两派，事件持续发酵中。',
    quote: '屏幕前的完美人设与屏幕后的真实面目之间，究竟有多远的距离？一段意外曝光的录音，揭开了这个拥有千万粉丝的网红不为人知的另一面。',
    author: '吃瓜小编',
    date: '2026-07-06',
    category: '网红塌房',
    tag: '独家爆料',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20darkened%20studio%20scene%20with%20a%20broken%20smartphone%20screen%20on%20a%20dark%20wooden%20table%2C%20surrounded%20by%20scattered%20microphone%20and%20headphones%2C%20warm%20amber%20spotlight%20creating%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20editorial%20photography%20style%2C%20dramatic%20composition%2C%20dark%20moody%20background%20with%20gossip%20magazine%20aesthetic&width=1600&height=900&seq=hero-gossip-01&orientation=landscape',
    content: `<p>7月5日下午，拥有超过两千万粉丝的顶流网红"甜心酱"在例行直播中遭遇了一场意外的翻车事件。在直播过程中，甜心酱的手机不慎连接到了直播间的蓝牙音箱，一段她与经纪人的私下通话内容被完整地播放给了直播间内的数十万观众。</p>
<p>在这段通话中，甜心酱用极其轻蔑的语气评价了她的粉丝群体，称他们为"一群没脑子的韭菜"，并透露自己代言的某款护肤品"自己从来不用，效果都是P的"。更令人震惊的是，她还与经纪人讨论了如何利用粉丝的同情心策划一场"抑郁症"公关事件，以应对即将到来的合同纠纷。</p>
<p>通话内容被直播出去后，直播间瞬间炸锅。弹幕从"？？？"迅速演变为大规模的脱粉和谩骂。在短短五分钟内，直播间的观众人数从30万飙升到了120万，但甜心酱的粉丝数却在以每分钟数千的速度急剧下降。</p>
<p>意识到情况不对的甜心酱匆忙关闭了直播，但为时已晚。完整录音已经被观众录屏保存，并在微博、抖音、B站等平台迅速传播。不到两个小时，"甜心酱翻车"就登上了微博热搜榜首。</p>
<p>与甜心酱合作的七大品牌在事发后24小时内相继发表声明，宣布终止与她的所有商业合作。其中一家美妆品牌的负责人表示："我们对其言论感到震惊和愤怒，这完全违背了我们品牌的核心价值观。"</p>
<p>甜心酱的粉丝群体也迅速分裂为两派。一部分铁粉坚持认为"这是恶意剪辑的录音"，另一部分则表示"心碎了，这些年付出的真情实感都被当成了笑话"。粉丝后援会会长在社交平台发文宣布卸任，并写道："我不知道该怎么面对大家，这些年我们守护的到底是什么？"</p>
<p>法律人士指出，如果甜心酱代言的品牌起诉其违约，根据代言合同的通常条款，她可能面临高达数千万元的违约金赔偿。而这场风波对整个网红行业的冲击才刚刚开始，多个MCN机构已经紧急召开了内部会议，反思旗下艺人的言行管理问题。</p>`,
    relatedIds: ['article-005', 'article-013', 'article-004', 'article-008'],
  },
};

export const defaultArticleContent = '<p>该文章正在编辑中，请稍后再来查看完整内容。</p>';